import { Stack, YStack } from '@mythical/ui'
import { Video as VideoType } from 'app/blocks/video'
import React from 'react'

import VideoPlayer from '../primitive/VideoPlayer'
import { observer } from 'mobx-react-lite'
import { useStores } from 'app/store'

interface Props {
  contentId: string
  title?: string
  thumbnail?: string
  block: VideoType
  planLevel: number | 'free'
  currentProgress?: number
  onVideoPlay?: () => void
  onVideoPause?: () => void
  onVideoEnd?: () => void
  onVideoProgress?: (progress: number) => void
}

export const ContentVideoArea: React.FC<Props> = observer(
  ({ block, ...rest }) => {
    const { userStore } = useStores()

    const data = JSON.parse(block.videoData)

    return (
      <YStack
        fs={1}
        fg={1}
        position="relative"
        alignContent="center"
        justifyContent="center"
      >
        <Stack aspectRatio={16 / 9} w="100%">
          <VideoPlayer
            id={block.id}
            url={block.video}
            player={block.player}
            data={data}
            captions={block.closedCaptions}
            currentProgress={rest.currentProgress}
            {...rest}
            userStore={userStore}
            contentId={rest.contentId}
          />
        </Stack>
      </YStack>
    )
  },
)

ContentVideoArea.displayName = 'ContentVideoArea'
